module.exports = __webpack_public_path__ + "static/media/pic3.d74bc4c5.jpg";